class InvoiceService {
    axiosInstance;
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    adminPortal = {
        receivable: {
            fetch: async (receivableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/receivable/${receivableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/receivable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data.results];
                    }, []);
                    return {
                        total: data.length,
                        offset: query?.offset || 0,
                        results: data,
                        thisBatch: data.length,
                    };
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/receivable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/receivable`, input);
                return data;
            },
            update: async (receivableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/receivable/${receivableId}`, input);
                return data;
            },
            customerAccessToken: {
                create: async (create) => {
                    const { data } = await this.axiosInstance.mainInstance.post(`/invoice/receivable/customer-access-token`, create);
                    return data;
                },
            },
            pdf: {
                fetch: async (receivableID) => {
                    const res = await this.axiosInstance.mainInstance.get(`/pdf/admin-portal/invoice/${receivableID}`, {
                        responseType: 'blob',
                    });
                    return res.data;
                },
            },
        },
        payable: {
            fetch: async (payableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payable/${payableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/payable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data.results];
                    }, []);
                    return {
                        total: data.length,
                        offset: query?.offset || 0,
                        results: data,
                        thisBatch: data.length,
                    };
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payable`, input);
                return data;
            },
            update: async (payableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/payable/${payableId}`, input);
                return data;
            },
            review: async (payableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/payable/${payableId}/review`, input);
                return data;
            },
        },
        payment: {
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payment`, {
                    params: query,
                });
                return data;
            },
            fetch: async (paymentId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/payment/${paymentId}`);
                return data;
            },
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/payment/${invoiceId}`, input);
                return data;
            },
        },
        refund: {
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/refund/${invoiceId}`, input);
                return data;
            },
        },
        pdf: {
            fetch: async (invoiceId, consolidate) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/admin-portal/invoice/${invoiceId}`, {
                    params: {
                        consolidate: consolidate,
                    },
                    responseType: 'blob',
                });
                return res.data;
            },
        },
        gmvSummary: async (query) => {
            const { data } = await this.axiosInstance.mainInstance.get(`/invoice/app-admin/gmv-summary`, {
                params: query,
            });
            return data;
        },
        coupon: {
            fetch: async (couponId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/sourgum-internal/coupon/${couponId}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/sourgum-internal/coupon`, {
                    params: query,
                });
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/sourgum-internal/coupon`, input);
                return data;
            },
            update: async (couponId, input) => {
                const { data } = await this.axiosInstance.mainInstance.patch(`/invoice/sourgum-internal/coupon/${couponId}`, input);
                return data;
            },
        },
        accountCredit: {
            fetch: async (accountCreditId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/account-credit/${accountCreditId}`);
                return data;
            },
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/account-credit`, {
                    params: query,
                });
                return data;
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/account-credit`, input);
                return data;
            },
        },
        // TODO: PUT A REAL TYPE ON HERE
        billingPeriod: {
            generateInvoice: async (billingPeriodId) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/v2/billing-period`, {
                    id: billingPeriodId,
                    suppressIssueInvoice: true,
                });
                return data;
            },
        },
        autopay: {
            delete: async (autopayId) => {
                await this.axiosInstance.mainInstance.delete(`/invoice/autopay/${autopayId}`);
            },
        },
    };
    wayste = {
        reports: {
            salesTaxLiability: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/reports/tax-liability`, input);
                return data;
            },
            payemntsBreakdown: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/reports/payments-breakdown`, input);
                return data;
            },
            getMetabaseUrl: async (dashboardId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/reports/metabase/url/${dashboardId}`);
                return data;
            },
        },
        receivable: {
            fetch: async (receivableId) => {
                if (!receivableId) {
                    throw new Error('receivableId is required');
                }
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/receivable/${receivableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/wayste/receivable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data.results];
                    }, []);
                    return {
                        total: data.length,
                        offset: query?.offset || 0,
                        results: data,
                        thisBatch: data.length,
                    };
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/receivable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/receivable`, input);
                return data;
            },
            update: async (receivableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/wayste/receivable/${receivableId}`, input);
                return data;
            },
            charge: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/receivable-with-charge`, input);
                return data;
            },
            review: async (receivableID, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/wayste/receivable/${receivableID}/review`, input);
                return data;
            },
        },
        payable: {
            fetch: async (payableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/payable/${payableId}`);
                return data;
            },
            query: async (query) => {
                const ids = query?.orderID?.split(',');
                if (ids && ids.length > 50) {
                    const promises = [];
                    for (let i = 0; i < ids.length; i += 50) {
                        const batch = ids.slice(i, i + 50);
                        promises.push(this.axiosInstance.mainInstance.get(`/invoice/wayste/payable`, {
                            params: {
                                ...query,
                                orderID: batch.join(','),
                            },
                        }));
                    }
                    const responses = await Promise.all(promises);
                    const data = responses.reduce((acc, res) => {
                        return [...acc, ...res.data];
                    }, []);
                    return data;
                }
                else {
                    const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/payable`, {
                        params: query,
                    });
                    return data;
                }
            },
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/payable`, input);
                return data;
            },
            update: async (payableId, input) => {
                const { data } = await this.axiosInstance.mainInstance.put(`/invoice/wayste/payable/${payableId}`, input);
                return data;
            },
        },
        payment: {
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/payment/${invoiceId}`, input);
                return data;
            },
        },
        refund: {
            /**
             *
             * @param invoiceId - This is the invoice details id, not the payable or receivable id
             */
            create: async (invoiceId, input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste/refund/${invoiceId}`, input);
                return data;
            },
        },
        pdf: {
            fetch: async (receivableID) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/${receivableID}`, {
                    responseType: 'blob',
                });
                return res.data;
            },
            summary: {
                fetch: async (customerID, includeInvoices) => {
                    const res = await this.axiosInstance.mainInstance.post(`${this.axiosInstance.mainInstance.defaults.baseURL}/pdf/hauler/invoice/invoice-summary`, {
                        customerID,
                        includeInvoices,
                    }, { responseType: 'blob' });
                    return res.data;
                },
            },
            getBulkPDFs: async (receivableIDs) => {
                const res = await this.axiosInstance.mainInstance.post(`/pdf/hauler/invoice/bulk-summary`, { receivableIDs }, { responseType: 'blob' });
                return res.data;
            },
        },
    };
    /**
     * Represents the customer portal functionality of the Invoice service.
     */
    customerPortal = {
        // Public routes for customer portal without authentication
        public: {
            paymentRequest: {
                create: async (token) => {
                    const res = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/receivable/checkout/request/${token}`);
                    return res.data;
                },
            },
            pdf: {
                fetch: async (token) => {
                    const res = await this.axiosInstance.mainInstance.get(`/pdf/customer-portal/invoice/token/${token}`, {
                        responseType: 'blob',
                    });
                    return res;
                },
            },
        },
        paymentRequest: {
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/customer-portal/payment/request`, input);
                return data;
            },
        },
        pdf: {
            fetch: async (receivableID) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/customer-portal/invoice/${receivableID}`, {
                    responseType: 'blob',
                });
                return res.data;
            },
        },
        // Subroutes for receivables
        receivable: {
            /**
             * Fetches a receivable by its id
             * @param receivableId - The id of the receivable to fetch
             * @returns A promise that resolves to the requested receivable object
             */
            fetch: async (receivableId) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/receivable/${receivableId}`);
                return data;
            },
            /**
             * Queries for receivables
             * @param query - The query to use for the search
             * @returns A promise that resolves to a paginated result of receivables
             */
            query: async (query) => {
                const { data } = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/receivable`, {
                    params: query,
                });
                return data;
            },
        },
        summary: async () => {
            const { data } = await this.axiosInstance.mainInstance.get(`/invoice/customer-portal/summary`);
            return data;
        },
    };
    waysteDashboard = {
        customerSummary: async () => {
            const { data } = await this.axiosInstance.mainInstance.get(`/invoice/wayste/customer-summary`);
            return data;
        },
        pdf: {
            fetch: async (receivableID) => {
                const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/wayste-dashboard/${receivableID}`, {
                    responseType: 'blob',
                });
                return res.data;
            },
        },
        paymentRequest: {
            create: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste-dashboard/payment/request`, input);
                return data;
            },
            process: async (input) => {
                const { data } = await this.axiosInstance.mainInstance.post(`/invoice/wayste-dashboard/payment/process`, input);
                return data;
            },
        },
    };
    /**
     * @deprecated use appropriate pathway for rest calls
     */
    pdf = {
        getPDF: async (receivableID) => {
            const res = await this.axiosInstance.mainInstance.get(`/pdf/hauler/invoice/${receivableID}`, {
                responseType: 'blob',
            });
            return res.data;
        },
        sendPDF: async (receivableID, sendPDFParams) => {
            return await this.axiosInstance.mainInstance.post(`/pdf/hauler/invoice/${receivableID}/send`, {
                ...sendPDFParams,
            });
        },
    };
}
export default InvoiceService;
//# sourceMappingURL=Invoice.service.js.map